// src/pages/BusinessSupport.tsx
import React from 'react';
import CategoryPage from './CategoryPage';

const BusinessSupport: React.FC = () => <CategoryPage categoryId="business" art="chart" />;

export default BusinessSupport;
